var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlide2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 249.094,
    height: 176.019,
    viewBox: "0 0 249.094 176.019",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "slide2",
    transform: "translate(-232.75 -67.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(232.75 67.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M486.568,601.585l-5.33-2.244-3.656-26.718H428.894l-3.963,26.609-4.768,2.384a1.132,1.132,0,0,0,.506,2.145h65.46a1.132,1.132,0,0,0,.439-2.176Z",
    transform: "translate(-328.974 -427.742)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M501.829,536.371H262.209c-2.618,0-4.737-1.457-4.737-3.249V510H506.566v23.122c0,1.791-2.119,3.245-4.737,3.249Z",
    transform: "translate(-257.472 -375.921)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M506.174,419.5H257.08V275.192a5.719,5.719,0,0,1,5.712-5.712h237.67a5.719,5.719,0,0,1,5.712,5.712Z",
    transform: "translate(-257.08 -269.48)",
    fill: "#3e3e3e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M514.344,433.287H280.562a4.831,4.831,0,0,1-4.694-4.948V293.216a4.831,4.831,0,0,1,4.694-4.948H514.344a4.831,4.831,0,0,1,4.694,4.948V428.339a4.831,4.831,0,0,1-4.694,4.948Z",
    transform: "translate(-272.906 -285.915)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13",
    transform: "translate(57.197 18.938)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M595.331,385.445h-3.758V348.892l8.54-.171Z",
    transform: "translate(-480.7 -275.2)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M677.374,385.445h3.758V348.892l-8.54-.171Z",
    transform: "translate(-544.637 -275.2)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M744.216,685.665l-8-.073A2.6,2.6,0,0,1,733,683.068h0a2.6,2.6,0,0,1,1.472-2.342l1.824-.877,5.927-4.051,4.27,1.2.818,3.68A4.2,4.2,0,0,1,744.216,685.665Z",
    transform: "translate(-631.348 -570.336)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M846.3,685.45l-8-.073a2.6,2.6,0,0,1-3.222-2.523h0a2.6,2.6,0,0,1,1.472-2.342l1.824-.877,5.927-4.051,4.27,1.2.818,3.68A4.2,4.2,0,0,1,846.3,685.45Z",
    transform: "translate(-711.909 -570.166)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M795.7,458.255,783.929,457.2l-1.55-13.809-3.471,13.361-11.9-1.063c.439-8.182,1.383-15.006,3.587-18.447l24.938-4.441Z",
    transform: "translate(-658.186 -378.573)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 6.361,
    cy: 6.361,
    r: 6.361,
    transform: "translate(119.256 3.008)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M829.15,247.117l-11.1-1.366c1.413-3.008,2.049-5.817,1.025-8.2h8.541C826.292,239.908,827.473,243.4,829.15,247.117Z",
    transform: "translate(-698.467 -224.485)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M806.4,298.879c-7.812,5.728-16.338,7.683-25.621,5.637,5.632-12.859,4.828-25.532,0-38.09l8.882-3.758c2.49,2.429,5.347,2.482,8.54.342l8.711,1.879C805.32,277.415,804.786,289.052,806.4,298.879Z",
    transform: "translate(-669.056 -244.305)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M816.629,179.389l-1.074-.43a7.328,7.328,0,0,1,5.371-2.258l-.879-.968a3.736,3.736,0,0,1,4.1,1.4,19.061,19.061,0,0,1,2.955,4.153h1.15l-.48,1.057,1.68,1.057-1.725-.19a5.849,5.849,0,0,1-.163,2.738l.046.836a25.693,25.693,0,0,1-2-3.523v1.075s-1.074-.968-1.074-1.613l-.586.753-.293-1.183-3.613,1.183.586-.968-2.246.323.879-1.183s-2.539,1.4-2.637,2.58a6.343,6.343,0,0,1-1.367,2.688l-.586-1.075S813.8,181,816.629,179.389Z",
    transform: "translate(-695.704 -175.573)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M759.752,465.428H721.171a1.477,1.477,0,0,1-1.476-1.476v-5.9a1.477,1.477,0,0,1,1.476-1.476h38.582a1.478,1.478,0,0,1,1.476,1.476v5.9A1.477,1.477,0,0,1,759.752,465.428Z",
    transform: "translate(-620.85 -397.33)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M749.362,471.626a1.254,1.254,0,1,0,0,2.507h27a1.254,1.254,0,1,0,.041-2.507H749.362Z",
    transform: "translate(-643.273 -409.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M776.245,367.339l1.961,3.5a3.1,3.1,0,0,1-1.924,4.522h0a3.1,3.1,0,0,1-3.887-3.063l.092-4.784c-1.473-8.5-2.669-16.556-2.391-22.205h6.832l-1.367,6.491Z",
    transform: "translate(-660.593 -309.521)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M881.747,359.882l-1.437,2.394a2.766,2.766,0,0,1-4.609.2h0a2.766,2.766,0,0,1,.629-3.878l2.512-1.795,3.587-14.86-2.22-6.149,6.149-1.025C889.246,341.446,886.338,350.341,881.747,359.882Z",
    transform: "translate(-743.548 -301.209)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M776.059,289.768l-9.053-.512.622-9.7a6.116,6.116,0,0,1,4.55-6.052l1.148-.3Z",
    transform: "translate(-658.187 -252.617)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M900.144,284.647l-8.37,2.05V270.64l.345-.022a5.746,5.746,0,0,1,5.989,4.531Z",
    transform: "translate(-756.65 -250.57)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M319.257,253.9H254.533a1.478,1.478,0,0,1-1.476-1.476V216.368a1.478,1.478,0,0,1,1.476-1.476h64.725a1.478,1.478,0,0,1,1.476,1.476V252.42A1.478,1.478,0,0,1,319.257,253.9Z",
    transform: "translate(-252.593 -206.602)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M318.32,321.969H251.909a1.055,1.055,0,0,1-1.054-1.054V215.505a1.055,1.055,0,0,1,1.054-1.054H318.32a1.055,1.055,0,0,1,1.054,1.054v105.41A1.055,1.055,0,0,1,318.32,321.969Zm-66.411-107.1a.633.633,0,0,0-.632.632v105.41a.633.633,0,0,0,.632.633H318.32a.633.633,0,0,0,.633-.632V215.505a.633.633,0,0,0-.633-.632Z",
    transform: "translate(-250.855 -206.254)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 2.319,
    cy: 2.319,
    r: 2.319,
    transform: "translate(6.578 62.262)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M375.115,469.747H336.533a1.477,1.477,0,0,1-1.476-1.476v-5.9a1.477,1.477,0,0,1,1.476-1.476h38.582a1.478,1.478,0,0,1,1.476,1.476v5.9A1.478,1.478,0,0,1,375.115,469.747Z",
    transform: "translate(-317.305 -400.738)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M375.8,502.314H334.268a.211.211,0,1,1,0-.422H375.8a.211.211,0,0,1,0,.422Z",
    transform: "translate(-316.516 -433.094)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 2.319,
    cy: 2.319,
    r: 2.319,
    transform: "translate(6.578 76.177)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M375.115,535.747H336.533a1.477,1.477,0,0,1-1.476-1.476v-5.9a1.478,1.478,0,0,1,1.476-1.476h38.582a1.478,1.478,0,0,1,1.476,1.476v5.9a1.478,1.478,0,0,1-1.476,1.476Z",
    transform: "translate(-317.305 -452.823)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M375.8,568.314H334.268a.211.211,0,1,1,0-.422H375.8a.211.211,0,0,1,0,.422Z",
    transform: "translate(-316.516 -485.18)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 2.319,
    cy: 2.319,
    r: 2.319,
    transform: "translate(6.578 90.091)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M352.556,601.747H336.533a1.477,1.477,0,0,1-1.476-1.476v-5.9a1.477,1.477,0,0,1,1.476-1.476h16.023a1.478,1.478,0,0,1,1.476,1.476v5.9A1.478,1.478,0,0,1,352.556,601.747Z",
    transform: "translate(-317.305 -504.909)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M353.242,634.314H334.268a.211.211,0,1,1,0-.422h18.975a.211.211,0,1,1,0,.422Z",
    transform: "translate(-316.516 -537.265)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M459.556,601.747H443.533a1.477,1.477,0,0,1-1.476-1.476v-5.9a1.477,1.477,0,0,1,1.476-1.476h16.023a1.478,1.478,0,0,1,1.476,1.476v5.9A1.478,1.478,0,0,1,459.556,601.747Z",
    transform: "translate(-401.746 -504.909)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M460.242,634.314H441.268a.211.211,0,0,1,0-.422h18.975a.211.211,0,0,1,0,.422Z",
    transform: "translate(-400.957 -537.265)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2",
    "data-name": "Path 40",
    d: "M288.724,268.445a1.254,1.254,0,1,0,0,2.507h50.617a1.254,1.254,0,0,0,.041-2.507H288.724Z",
    transform: "translate(-279.751 -248.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-3",
    "data-name": "Path 40",
    d: "M288.724,301.445a1.254,1.254,0,1,0,0,2.507h50.617a1.254,1.254,0,0,0,.041-2.507H288.724Z",
    transform: "translate(-279.751 -274.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-4",
    "data-name": "Path 40",
    d: "M288.724,334.445a1.254,1.254,0,1,0,0,2.507h50.617a1.254,1.254,0,0,0,.041-2.507H288.724Z",
    transform: "translate(-279.751 -300.95)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M510.782,682.068l-.531-.53a.123.123,0,0,0-.087-.036h-.258a.123.123,0,0,0-.087.21l.294.294h-2.345a.211.211,0,1,0,0,.422h2.345l-.264.263a.141.141,0,0,0,.1.24h.209a.141.141,0,0,0,.1-.041l.526-.525A.21.21,0,0,0,510.782,682.068Z",
    transform: "translate(-453.437 -574.837)",
    fill: "#00b9ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M503.43,675.638a3.373,3.373,0,1,1,3.373-3.373,3.373,3.373,0,0,1-3.373,3.373Zm0-6.325a2.952,2.952,0,1,0,2.952,2.952A2.952,2.952,0,0,0,503.43,669.314Z",
    transform: "translate(-447.518 -564.886)",
    fill: "#3f3d56"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlide2);
export default __webpack_public_path__ + "static/media/slide2.fa44494f0158bf6ba6a5ed963e5cf1f0.svg";
export { ForwardRef as ReactComponent };